import * as React from 'react';

import classnames from 'classnames';

import {Link} from '../link/link';
// @ts-expect-error
import {LocationEnum, Popover} from '../popover/popover';

import styles from './select-menu.module.css';

type Option = {
    label: string | React.ReactElement<any>;
    icon?: React.ReactElement<any>;
    key?: string;
    isDisabled?: boolean;
    handleSelect?: (option: any, arg2: Event) => any;
    tooltip?: string;
};

// TODO (@ianvs): Use flow 0.42 type spread here when babel supports it
// Really, the submenu will not have yet another nested submenu, but I couldn't
// get flow to play nicely when making it an array of Options
export type SelectMenuOption = {
    label: string | React.ReactElement<any>;
    icon?: React.ReactElement<any>;
    key?: string;
    isDisabled?: boolean;
    variant?: 'primary' | 'secondary' | 'destructive';
    handleSelect?: (option: any, arg2: Event) => any;
    submenu?: Array<SelectMenuOption>;
    tooltipTextOnClose?: string | null | undefined;
};

type Props = {
    anchor: HTMLElement | null | undefined;
    options: Array<SelectMenuOption>;
    onClose: (...args: any) => any;
    location?: LocationEnum;
    customStyles?: any;
    offsetX?: number;
    offsetY?: number;
    moreBorderRadius?: boolean;
};

type State = {
    submenuOption: Array<Option> | null | undefined;
};

export class SelectMenu extends React.Component<Props, State> {
    static defaultProps = {
        onClose: () => {},
    };

    state = {
        submenuOption: null,
    };

    render() {
        const containerClassName = classnames(styles.container, {
            [styles['container--more-border-radius']]: this.props.moreBorderRadius,
        });

        return (
            <Popover
                onBlur={this.props.onClose}
                location={this.props.location}
                anchor={this.props.anchor}
                customStyles={this.props.customStyles}
                noDefaultStyling={true}
                offsetX={this.props.offsetX}
                offsetY={this.props.offsetY}
            >
                <div className={containerClassName}>
                    {this.renderMenuItems(
                        this.state.submenuOption ? this.state.submenuOption : this.props.options
                    )}
                </div>
            </Popover>
        );
    }

    renderMenuItems = (options: Array<SelectMenuOption>): React.ReactElement<any>[] => {
        const isSubmenu = Boolean(this.state.submenuOption);

        return options.map((opt, index) => {
            const styleNames = classnames({
                [styles['option-container--disabled']]: opt.isDisabled,
                [styles['option-container--enabled']]: !opt.isDisabled,
                [styles['option-container--submenu']]: isSubmenu,
                [styles['option-container--secondary']]:
                    !opt.variant || opt.variant === 'secondary',
                [styles['option-container--destructive']]: opt.variant === 'destructive',
                [styles['option-container--primary']]: opt.variant === 'primary',
            });

            // If the label is a Link, we want to remove the underline
            const label =
                typeof opt.label !== 'string' && opt.label.type === Link
                    ? React.cloneElement(opt.label, {preventUnderline: true})
                    : opt.label;

            return (
                <button
                    key={opt.key || index}
                    onClick={
                        !opt.isDisabled
                            ? // @ts-expect-error
                              (e) => this.handleSelect(opt, e)
                            : (e) => {
                                  e.stopPropagation();
                              }
                    }
                    // @ts-expect-error
                    title={opt.tooltip}
                    className={styleNames}
                >
                    {opt.icon ? (
                        <div className={styles['icon-container']}>{opt.icon}</div>
                    ) : undefined}
                    {label}
                </button>
            );
        });
    };

    handleSelect = (opt: SelectMenuOption, e: Event) => {
        e.stopPropagation();
        if (opt.submenu) {
            this.setState({submenuOption: opt.submenu});

            return;
        }
        this.props.onClose(e, opt.tooltipTextOnClose);

        if (typeof opt.handleSelect === 'function') {
            opt.handleSelect(opt, e);
        }
    };
}
